<div>
  <div>
    <button class="card-button" mat-flat-button color="accent" (click)="close()">{{'close' | translation}}</button>
  </div>
  <div>
    <iframe src="assets/changelog.txt"></iframe>
  </div>
</div>
